const ACS_NOTES = [
  'The results are projected to the Census Block associated with each location, which can include hundreds of households.',
  'Results are from the 2015-2019 5-year American Community Survey.',
]

const currentCongress = 'cd119'

export default {
  census: [
    {
      name: 'census',
      apiName: 'census',
      detailsUrl: 'https://www.geocod.io/guides/census/',
      title: '🇺🇸 Census Geographies',
      options: {
        'census2024': 'As of the 2024 Census year (most recent)',
        'census2023': 'As of the 2023 Census year',
        'census2022': 'As of the 2022 Census year',
        'census2021': 'As of the 2021 Census year',
        'census2020': 'As of the 2020 Census year',
        'census2019': 'As of the 2019 Census year',
        'census2018': 'As of the 2018 Census year',
        'census2017': 'As of the 2017 Census year',
        'census2016': 'As of the 2016 Census year',
        'census2015': 'As of the 2015 Census year',
        'census2014': 'As of the 2014 Census year',
        'census2013': 'As of the 2013 Census year',
        'census2012': 'As of the 2012 Census year',
        'census2011': 'As of the 2011 Census year',
        'census2010': 'As of the 2010 Census year',
        'census2000': 'As of the 2000 Census year',
      },
      description: null,
      bulletPoints: ['FIPS Codes (GeoID)', 'Census Tract Code', 'Census Block Code', 'Metro/Micro Statistical Area'],
      columns: [
        'Census Year',
        'State FIPS',
        'County FIPS',
        'Place Name',
        'Place FIPS',
        'Census Tract Code',
        'Census Block Code',
        'Census Block Group',
        'Full FIPS (block)',
        'Full FIPS (tract)',
        'Metro/Micro Statistical Area Name',
        'Metro/Micro Statistical Area Code',
        'Metro/Micro Statistical Area Type',
        'Combined Statistical Area Name',
        'Combined Statistical Area Code',
        'Metropolitan Division Name',
        'Metropolitan Division Code',
        'County Subdivision Name',
        'County Subdivision FIPS',
        'County Subdivision Class Code',
        'County Subdivision Class Description',
      ],
    },
    {
      name: 'acs-economics',
      apiName: 'economics',
      detailsUrl: 'https://www.geocod.io/guides/income-data-census/',
      title: '🇺🇸 Census ACS Economics',
      description: null,
      bulletPoints: ['Median household income', 'Number of households', 'Household income by amount'],
      notes: ACS_NOTES,
      columns: [
        'ACS Economics/Number of households/Total/Value',
        'ACS Economics/Number of households/Total/Margin of error',
        'ACS Economics/Median household income/Total/Value',
        'ACS Economics/Median household income/Total/Margin of error',
        'ACS Economics/Household income/Less than $10,000/Value',
        'ACS Economics/Household income/Less than $10,000/Margin of error',
        'ACS Economics/Household income/Less than $10,000/Percentage',
        'ACS Economics/Household income/$10,000 to $14,999/Value',
        'ACS Economics/Household income/$10,000 to $14,999/Margin of error',
        'ACS Economics/Household income/$10,000 to $14,999/Percentage',
        'ACS Economics/Household income/$15,000 to $19,999/Value',
        'ACS Economics/Household income/$15,000 to $19,999/Margin of error',
        'ACS Economics/Household income/$15,000 to $19,999/Percentage',
        'ACS Economics/Household income/$20,000 to $24,999/Value',
        'ACS Economics/Household income/$20,000 to $24,999/Margin of error',
        'ACS Economics/Household income/$20,000 to $24,999/Percentage',
        'ACS Economics/Household income/$25,000 to $29,999/Value',
        'ACS Economics/Household income/$25,000 to $29,999/Margin of error',
        'ACS Economics/Household income/$25,000 to $29,999/Percentage',
        'ACS Economics/Household income/$30,000 to $34,999/Value',
        'ACS Economics/Household income/$30,000 to $34,999/Margin of error',
        'ACS Economics/Household income/$30,000 to $34,999/Percentage',
        'ACS Economics/Household income/$35,000 to $39,999/Value',
        'ACS Economics/Household income/$35,000 to $39,999/Margin of error',
        'ACS Economics/Household income/$35,000 to $39,999/Percentage',
        'ACS Economics/Household income/$40,000 to $44,999/Value',
        'ACS Economics/Household income/$40,000 to $44,999/Margin of error',
        'ACS Economics/Household income/$40,000 to $44,999/Percentage',
        'ACS Economics/Household income/$45,000 to $49,999/Value',
        'ACS Economics/Household income/$45,000 to $49,999/Margin of error',
        'ACS Economics/Household income/$45,000 to $49,999/Percentage',
        'ACS Economics/Household income/$50,000 to $59,999/Value',
        'ACS Economics/Household income/$50,000 to $59,999/Margin of error',
        'ACS Economics/Household income/$50,000 to $59,999/Percentage',
        'ACS Economics/Household income/$60,000 to $74,999/Value',
        'ACS Economics/Household income/$60,000 to $74,999/Margin of error',
        'ACS Economics/Household income/$60,000 to $74,999/Percentage',
        'ACS Economics/Household income/$75,000 to $99,999/Value',
        'ACS Economics/Household income/$75,000 to $99,999/Margin of error',
        'ACS Economics/Household income/$75,000 to $99,999/Percentage',
        'ACS Economics/Household income/$100,000 to $124,999/Value',
        'ACS Economics/Household income/$100,000 to $124,999/Margin of error',
        'ACS Economics/Household income/$100,000 to $124,999/Percentage',
        'ACS Economics/Household income/$125,000 to $149,999/Value',
        'ACS Economics/Household income/$125,000 to $149,999/Margin of error',
        'ACS Economics/Household income/$125,000 to $149,999/Percentage',
        'ACS Economics/Household income/$150,000 to $199,999/Value',
        'ACS Economics/Household income/$150,000 to $199,999/Margin of error',
        'ACS Economics/Household income/$150,000 to $199,999/Percentage',
        'ACS Economics/Household income/$200,000 or more/Value',
        'ACS Economics/Household income/$200,000 or more/Margin of error',
        'ACS Economics/Household income/$200,000 or more/Percentage',
      ],
    },
    {
      name: 'acs-demographics',
      apiName: 'demographics',
      detailsUrl: 'https://www.geocod.io/guides/demographics-census/',
      title: '🇺🇸 Census ACS Demographics',
      description: null,
      bulletPoints: ['Population by race and ethnicity', 'Median age', 'Population by age range', 'Population by sex'],
      notes: ACS_NOTES,
      columns: [
        'ACS Demographics/Median age/Total/Value',
        'ACS Demographics/Median age/Total/Margin of error',
        'ACS Demographics/Median age/Male/Value',
        'ACS Demographics/Median age/Male/Margin of error',
        'ACS Demographics/Median age/Female/Value',
        'ACS Demographics/Median age/Female/Margin of error',
        'ACS Demographics/Population by age range/Total/Value',
        'ACS Demographics/Population by age range/Total/Margin of error',
        'ACS Demographics/Population by age range/Male/Value',
        'ACS Demographics/Population by age range/Male/Margin of error',
        'ACS Demographics/Population by age range/Male/Percentage',
        'ACS Demographics/Population by age range/Male: Under 5 years/Value',
        'ACS Demographics/Population by age range/Male: Under 5 years/Margin of error',
        'ACS Demographics/Population by age range/Male: Under 5 years/Percentage',
        'ACS Demographics/Population by age range/Male: 5 to 9 years/Value',
        'ACS Demographics/Population by age range/Male: 5 to 9 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 5 to 9 years/Percentage',
        'ACS Demographics/Population by age range/Male: 10 to 14 years/Value',
        'ACS Demographics/Population by age range/Male: 10 to 14 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 10 to 14 years/Percentage',
        'ACS Demographics/Population by age range/Male: 15 to 17 years/Value',
        'ACS Demographics/Population by age range/Male: 15 to 17 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 15 to 17 years/Percentage',
        'ACS Demographics/Population by age range/Male: 18 and 19 years/Value',
        'ACS Demographics/Population by age range/Male: 18 and 19 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 18 and 19 years/Percentage',
        'ACS Demographics/Population by age range/Male: 20 years/Value',
        'ACS Demographics/Population by age range/Male: 20 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 20 years/Percentage',
        'ACS Demographics/Population by age range/Male: 21 years/Value',
        'ACS Demographics/Population by age range/Male: 21 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 21 years/Percentage',
        'ACS Demographics/Population by age range/Male: 22 to 24 years/Value',
        'ACS Demographics/Population by age range/Male: 22 to 24 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 22 to 24 years/Percentage',
        'ACS Demographics/Population by age range/Male: 25 to 29 years/Value',
        'ACS Demographics/Population by age range/Male: 25 to 29 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 25 to 29 years/Percentage',
        'ACS Demographics/Population by age range/Male: 30 to 34 years/Value',
        'ACS Demographics/Population by age range/Male: 30 to 34 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 30 to 34 years/Percentage',
        'ACS Demographics/Population by age range/Male: 35 to 39 years/Value',
        'ACS Demographics/Population by age range/Male: 35 to 39 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 35 to 39 years/Percentage',
        'ACS Demographics/Population by age range/Male: 40 to 44 years/Value',
        'ACS Demographics/Population by age range/Male: 40 to 44 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 40 to 44 years/Percentage',
        'ACS Demographics/Population by age range/Male: 45 to 49 years/Value',
        'ACS Demographics/Population by age range/Male: 45 to 49 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 45 to 49 years/Percentage',
        'ACS Demographics/Population by age range/Male: 50 to 54 years/Value',
        'ACS Demographics/Population by age range/Male: 50 to 54 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 50 to 54 years/Percentage',
        'ACS Demographics/Population by age range/Male: 55 to 59 years/Value',
        'ACS Demographics/Population by age range/Male: 55 to 59 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 55 to 59 years/Percentage',
        'ACS Demographics/Population by age range/Male: 60 and 61 years/Value',
        'ACS Demographics/Population by age range/Male: 60 and 61 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 60 and 61 years/Percentage',
        'ACS Demographics/Population by age range/Male: 62 to 64 years/Value',
        'ACS Demographics/Population by age range/Male: 62 to 64 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 62 to 64 years/Percentage',
        'ACS Demographics/Population by age range/Male: 65 and 66 years/Value',
        'ACS Demographics/Population by age range/Male: 65 and 66 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 65 and 66 years/Percentage',
        'ACS Demographics/Population by age range/Male: 67 to 69 years/Value',
        'ACS Demographics/Population by age range/Male: 67 to 69 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 67 to 69 years/Percentage',
        'ACS Demographics/Population by age range/Male: 70 to 74 years/Value',
        'ACS Demographics/Population by age range/Male: 70 to 74 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 70 to 74 years/Percentage',
        'ACS Demographics/Population by age range/Male: 75 to 79 years/Value',
        'ACS Demographics/Population by age range/Male: 75 to 79 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 75 to 79 years/Percentage',
        'ACS Demographics/Population by age range/Male: 80 to 84 years/Value',
        'ACS Demographics/Population by age range/Male: 80 to 84 years/Margin of error',
        'ACS Demographics/Population by age range/Male: 80 to 84 years/Percentage',
        'ACS Demographics/Population by age range/Male: 85 years and over/Value',
        'ACS Demographics/Population by age range/Male: 85 years and over/Margin of error',
        'ACS Demographics/Population by age range/Male: 85 years and over/Percentage',
        'ACS Demographics/Population by age range/Female/Value',
        'ACS Demographics/Population by age range/Female/Margin of error',
        'ACS Demographics/Population by age range/Female/Percentage',
        'ACS Demographics/Population by age range/Female: Under 5 years/Value',
        'ACS Demographics/Population by age range/Female: Under 5 years/Margin of error',
        'ACS Demographics/Population by age range/Female: Under 5 years/Percentage',
        'ACS Demographics/Population by age range/Female: 5 to 9 years/Value',
        'ACS Demographics/Population by age range/Female: 5 to 9 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 5 to 9 years/Percentage',
        'ACS Demographics/Population by age range/Female: 10 to 14 years/Value',
        'ACS Demographics/Population by age range/Female: 10 to 14 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 10 to 14 years/Percentage',
        'ACS Demographics/Population by age range/Female: 15 to 17 years/Value',
        'ACS Demographics/Population by age range/Female: 15 to 17 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 15 to 17 years/Percentage',
        'ACS Demographics/Population by age range/Female: 18 and 19 years/Value',
        'ACS Demographics/Population by age range/Female: 18 and 19 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 18 and 19 years/Percentage',
        'ACS Demographics/Population by age range/Female: 20 years/Value',
        'ACS Demographics/Population by age range/Female: 20 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 20 years/Percentage',
        'ACS Demographics/Population by age range/Female: 21 years/Value',
        'ACS Demographics/Population by age range/Female: 21 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 21 years/Percentage',
        'ACS Demographics/Population by age range/Female: 22 to 24 years/Value',
        'ACS Demographics/Population by age range/Female: 22 to 24 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 22 to 24 years/Percentage',
        'ACS Demographics/Population by age range/Female: 25 to 29 years/Value',
        'ACS Demographics/Population by age range/Female: 25 to 29 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 25 to 29 years/Percentage',
        'ACS Demographics/Population by age range/Female: 30 to 34 years/Value',
        'ACS Demographics/Population by age range/Female: 30 to 34 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 30 to 34 years/Percentage',
        'ACS Demographics/Population by age range/Female: 35 to 39 years/Value',
        'ACS Demographics/Population by age range/Female: 35 to 39 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 35 to 39 years/Percentage',
        'ACS Demographics/Population by age range/Female: 40 to 44 years/Value',
        'ACS Demographics/Population by age range/Female: 40 to 44 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 40 to 44 years/Percentage',
        'ACS Demographics/Population by age range/Female: 45 to 49 years/Value',
        'ACS Demographics/Population by age range/Female: 45 to 49 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 45 to 49 years/Percentage',
        'ACS Demographics/Population by age range/Female: 50 to 54 years/Value',
        'ACS Demographics/Population by age range/Female: 50 to 54 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 50 to 54 years/Percentage',
        'ACS Demographics/Population by age range/Female: 55 to 59 years/Value',
        'ACS Demographics/Population by age range/Female: 55 to 59 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 55 to 59 years/Percentage',
        'ACS Demographics/Population by age range/Female: 60 and 61 years/Value',
        'ACS Demographics/Population by age range/Female: 60 and 61 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 60 and 61 years/Percentage',
        'ACS Demographics/Population by age range/Female: 62 to 64 years/Value',
        'ACS Demographics/Population by age range/Female: 62 to 64 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 62 to 64 years/Percentage',
        'ACS Demographics/Population by age range/Female: 65 and 66 years/Value',
        'ACS Demographics/Population by age range/Female: 65 and 66 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 65 and 66 years/Percentage',
        'ACS Demographics/Population by age range/Female: 67 to 69 years/Value',
        'ACS Demographics/Population by age range/Female: 67 to 69 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 67 to 69 years/Percentage',
        'ACS Demographics/Population by age range/Female: 70 to 74 years/Value',
        'ACS Demographics/Population by age range/Female: 70 to 74 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 70 to 74 years/Percentage',
        'ACS Demographics/Population by age range/Female: 75 to 79 years/Value',
        'ACS Demographics/Population by age range/Female: 75 to 79 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 75 to 79 years/Percentage',
        'ACS Demographics/Population by age range/Female: 80 to 84 years/Value',
        'ACS Demographics/Population by age range/Female: 80 to 84 years/Margin of error',
        'ACS Demographics/Population by age range/Female: 80 to 84 years/Percentage',
        'ACS Demographics/Population by age range/Female: 85 years and over/Value',
        'ACS Demographics/Population by age range/Female: 85 years and over/Margin of error',
        'ACS Demographics/Population by age range/Female: 85 years and over/Percentage',
        'ACS Demographics/Sex/Total/Value',
        'ACS Demographics/Sex/Total/Margin of error',
        'ACS Demographics/Sex/Male/Value',
        'ACS Demographics/Sex/Male/Margin of error',
        'ACS Demographics/Sex/Male/Percentage',
        'ACS Demographics/Sex/Female/Value',
        'ACS Demographics/Sex/Female/Margin of error',
        'ACS Demographics/Sex/Female/Percentage',
        'ACS Demographics/Race and ethnicity/Total/Value',
        'ACS Demographics/Race and ethnicity/Total/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: White alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: White alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: White alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Black or African American alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Black or African American alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Black or African American alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: American Indian and Alaska Native alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: American Indian and Alaska Native alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: American Indian and Alaska Native alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Asian alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Asian alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Asian alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Some other race alone/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Some other race alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Some other race alone/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races including Some other race/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races including Some other race/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races including Some other race/Percentage',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Value',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Margin of error',
        'ACS Demographics/Race and ethnicity/Not Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: White alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: White alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: White alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Black or African American alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Black or African American alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Black or African American alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: American Indian and Alaska Native alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: American Indian and Alaska Native alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: American Indian and Alaska Native alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Asian alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Asian alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Asian alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Native Hawaiian and Other Pacific Islander alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Some other race alone/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Some other race alone/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Some other race alone/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races including Some other race/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races including Some other race/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races including Some other race/Percentage',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Value',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Margin of error',
        'ACS Demographics/Race and ethnicity/Hispanic or Latino: Two or more races: Two races excluding Some other race, and three or more races/Percentage',
      ],
    },
    {
      name: 'acs-housing',
      apiName: 'housing',
      detailsUrl: 'https://www.geocod.io/guides/housing-census/',
      title: '🇺🇸 Census ACS Housing',
      description: null,
      bulletPoints: ['Number of housing units', 'Occupancy status', 'Units in structure', 'Median value of owner-occupied housing units'],
      notes: ACS_NOTES,
      columns: [
        'ACS Housing/Number of housing units/Total/Value',
        'ACS Housing/Number of housing units/Total/Margin of error',
        'ACS Housing/Occupancy status/Occupied/Value',
        'ACS Housing/Occupancy status/Occupied/Margin of error',
        'ACS Housing/Occupancy status/Occupied/Percentage',
        'ACS Housing/Occupancy status/Vacant/Value',
        'ACS Housing/Occupancy status/Vacant/Margin of error',
        'ACS Housing/Occupancy status/Vacant/Percentage',
        'ACS Housing/Ownership of occupied units/Owner occupied/Value',
        'ACS Housing/Ownership of occupied units/Owner occupied/Margin of error',
        'ACS Housing/Ownership of occupied units/Owner occupied/Percentage',
        'ACS Housing/Ownership of occupied units/Renter occupied/Value',
        'ACS Housing/Ownership of occupied units/Renter occupied/Margin of error',
        'ACS Housing/Ownership of occupied units/Renter occupied/Percentage',
        'ACS Housing/Units in structure/1, detached unit/Value',
        'ACS Housing/Units in structure/1, detached unit/Margin of error',
        'ACS Housing/Units in structure/1, detached unit/Percentage',
        'ACS Housing/Units in structure/1, attached unit/Value',
        'ACS Housing/Units in structure/1, attached unit/Margin of error',
        'ACS Housing/Units in structure/1, attached unit/Percentage',
        'ACS Housing/Units in structure/2 units/Value',
        'ACS Housing/Units in structure/2 units/Margin of error',
        'ACS Housing/Units in structure/2 units/Percentage',
        'ACS Housing/Units in structure/3 or 4 units/Value',
        'ACS Housing/Units in structure/3 or 4 units/Margin of error',
        'ACS Housing/Units in structure/3 or 4 units/Percentage',
        'ACS Housing/Units in structure/5 to 9 units/Value',
        'ACS Housing/Units in structure/5 to 9 units/Margin of error',
        'ACS Housing/Units in structure/5 to 9 units/Percentage',
        'ACS Housing/Units in structure/10 to 19 unit/Value',
        'ACS Housing/Units in structure/10 to 19 unit/Margin of error',
        'ACS Housing/Units in structure/10 to 19 unit/Percentage',
        'ACS Housing/Units in structure/20 to 49 units/Value',
        'ACS Housing/Units in structure/20 to 49 units/Margin of error',
        'ACS Housing/Units in structure/20 to 49 units/Percentage',
        'ACS Housing/Units in structure/50 or more units/Value',
        'ACS Housing/Units in structure/50 or more units/Margin of error',
        'ACS Housing/Units in structure/50 or more units/Percentage',
        'ACS Housing/Units in structure/Mobile home units/Value',
        'ACS Housing/Units in structure/Mobile home units/Margin of error',
        'ACS Housing/Units in structure/Mobile home units/Percentage',
        'ACS Housing/Units in structure/Boat, RV, van, etc. units/Value',
        'ACS Housing/Units in structure/Boat, RV, van, etc. units/Margin of error',
        'ACS Housing/Units in structure/Boat, RV, van, etc. units/Percentage',
        'ACS Housing/Median value of owner-occupied housing units/Total/Value',
        'ACS Housing/Median value of owner-occupied housing units/Total/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/Less than $10,000/Value',
        'ACS Housing/Value of owner-occupied housing units/Less than $10,000/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/Less than $10,000/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$10,000 to $14,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$10,000 to $14,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$10,000 to $14,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$15,000 to $19,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$15,000 to $19,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$15,000 to $19,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$20,000 to $24,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$20,000 to $24,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$20,000 to $24,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$25,000 to $29,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$25,000 to $29,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$25,000 to $29,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$30,000 to $34,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$30,000 to $34,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$30,000 to $34,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$35,000 to $39,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$35,000 to $39,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$35,000 to $39,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$40,000 to $49,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$40,000 to $49,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$40,000 to $49,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$50,000 to $59,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$50,000 to $59,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$50,000 to $59,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$60,000 to $69,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$60,000 to $69,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$60,000 to $69,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$70,000 to $79,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$70,000 to $79,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$70,000 to $79,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$80,000 to $89,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$80,000 to $89,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$80,000 to $89,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$90,000 to $99,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$90,000 to $99,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$90,000 to $99,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$100,000 to $124,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$100,000 to $124,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$100,000 to $124,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$125,000 to $149,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$125,000 to $149,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$125,000 to $149,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$150,000 to $174,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$150,000 to $174,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$150,000 to $174,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$175,000 to $199,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$175,000 to $199,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$175,000 to $199,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$200,000 to $249,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$200,000 to $249,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$200,000 to $249,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$250,000 to $299,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$250,000 to $299,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$250,000 to $299,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$300,000 to $399,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$300,000 to $399,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$300,000 to $399,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$400,000 to $499,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$400,000 to $499,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$400,000 to $499,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$500,000 to $749,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$500,000 to $749,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$500,000 to $749,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$750,000 to $999,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$750,000 to $999,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$750,000 to $999,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$1,000,000 to $1,499,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$1,000,000 to $1,499,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$1,000,000 to $1,499,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$1,500,000 to $1,999,999/Value',
        'ACS Housing/Value of owner-occupied housing units/$1,500,000 to $1,999,999/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$1,500,000 to $1,999,999/Percentage',
        'ACS Housing/Value of owner-occupied housing units/$2,000,000 or more/Value',
        'ACS Housing/Value of owner-occupied housing units/$2,000,000 or more/Margin of error',
        'ACS Housing/Value of owner-occupied housing units/$2,000,000 or more/Percentage',
      ],
    },
    {
      name: 'acs-families',
      apiName: 'families',
      detailsUrl: 'https://www.geocod.io/guides/families-census/',
      title: '🇺🇸 Census ACS Families',
      description: null,
      bulletPoints: ['Household type', 'Household type by population', 'Household type by gender'],
      notes: ACS_NOTES,
      columns: [
        'ACS Families/Household type by household/Total/Value',
        'ACS Families/Household type by household/Total/Margin of error',
        'ACS Families/Household type by household/Family households/Value',
        'ACS Families/Household type by household/Family households/Margin of error',
        'ACS Families/Household type by household/Family households/Percentage',
        'ACS Families/Household type by household/Family households: Married-couple family/Value',
        'ACS Families/Household type by household/Family households: Married-couple family/Margin of error',
        'ACS Families/Household type by household/Family households: Married-couple family/Percentage',
        'ACS Families/Household type by household/Family households: Other family/Value',
        'ACS Families/Household type by household/Family households: Other family/Margin of error',
        'ACS Families/Household type by household/Family households: Other family/Percentage',
        'ACS Families/Household type by household/Family households: Other family: Male householder, no wife present/Value',
        'ACS Families/Household type by household/Family households: Other family: Male householder, no wife present/Margin of error',
        'ACS Families/Household type by household/Family households: Other family: Male householder, no wife present/Percentage',
        'ACS Families/Household type by household/Family households: Other family: Female householder, no husband present/Value',
        'ACS Families/Household type by household/Family households: Other family: Female householder, no husband present/Margin of error',
        'ACS Families/Household type by household/Family households: Other family: Female householder, no husband present/Percentage',
        'ACS Families/Household type by household/Nonfamily households/Value',
        'ACS Families/Household type by household/Nonfamily households/Margin of error',
        'ACS Families/Household type by household/Nonfamily households/Percentage',
        'ACS Families/Household type by household/Nonfamily households: Householder living alone/Value',
        'ACS Families/Household type by household/Nonfamily households: Householder living alone/Margin of error',
        'ACS Families/Household type by household/Nonfamily households: Householder living alone/Percentage',
        'ACS Families/Household type by household/Nonfamily households: Householder not living alone/Value',
        'ACS Families/Household type by household/Nonfamily households: Householder not living alone/Margin of error',
        'ACS Families/Household type by household/Nonfamily households: Householder not living alone/Percentage',
        'ACS Families/Household type by population/Total/Value',
        'ACS Families/Household type by population/Total/Margin of error',
        'ACS Families/Household type by population/In family households/Value',
        'ACS Families/Household type by population/In family households/Margin of error',
        'ACS Families/Household type by population/In family households/Percentage',
        'ACS Families/Household type by population/In family households: In married-couple family/Value',
        'ACS Families/Household type by population/In family households: In married-couple family/Margin of error',
        'ACS Families/Household type by population/In family households: In married-couple family/Percentage',
        'ACS Families/Household type by population/In family households: In married-couple family: Relatives/Value',
        'ACS Families/Household type by population/In family households: In married-couple family: Relatives/Margin of error',
        'ACS Families/Household type by population/In family households: In married-couple family: Relatives/Percentage',
        'ACS Families/Household type by population/In family households: In married-couple family: Nonrelatives/Value',
        'ACS Families/Household type by population/In family households: In married-couple family: Nonrelatives/Margin of error',
        'ACS Families/Household type by population/In family households: In married-couple family: Nonrelatives/Percentage',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family/Value',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family/Margin of error',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family/Percentage',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Relatives/Value',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Relatives/Margin of error',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Relatives/Percentage',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Nonrelatives/Value',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Nonrelatives/Margin of error',
        'ACS Families/Household type by population/In family households: In male householder, no wife present, family: Nonrelatives/Percentage',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family/Value',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family/Margin of error',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family/Percentage',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Relatives/Value',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Relatives/Margin of error',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Relatives/Percentage',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Nonrelatives/Value',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Nonrelatives/Margin of error',
        'ACS Families/Household type by population/In family households: In female householder, no husband present, family: Nonrelatives/Percentage',
        'ACS Families/Household type by population/In nonfamily households/Value',
        'ACS Families/Household type by population/In nonfamily households/Margin of error',
        'ACS Families/Household type by population/In nonfamily households/Percentage',
        'ACS Families/Marital status/Male/Value',
        'ACS Families/Marital status/Male/Margin of error',
        'ACS Families/Marital status/Male/Percentage',
        'ACS Families/Marital status/Male: Never married/Value',
        'ACS Families/Marital status/Male: Never married/Margin of error',
        'ACS Families/Marital status/Male: Never married/Percentage',
        'ACS Families/Marital status/Male: Now married/Value',
        'ACS Families/Marital status/Male: Now married/Margin of error',
        'ACS Families/Marital status/Male: Now married/Percentage',
        'ACS Families/Marital status/Male: Now married: Married, spouse present/Value',
        'ACS Families/Marital status/Male: Now married: Married, spouse present/Margin of error',
        'ACS Families/Marital status/Male: Now married: Married, spouse present/Percentage',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent/Value',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent/Margin of error',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent/Percentage',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Separated/Value',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Separated/Margin of error',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Separated/Percentage',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Other/Value',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Other/Margin of error',
        'ACS Families/Marital status/Male: Now married: Married, spouse absent: Other/Percentage',
        'ACS Families/Marital status/Male: Widowed/Value',
        'ACS Families/Marital status/Male: Widowed/Margin of error',
        'ACS Families/Marital status/Male: Widowed/Percentage',
        'ACS Families/Marital status/Male: Divorced/Value',
        'ACS Families/Marital status/Male: Divorced/Margin of error',
        'ACS Families/Marital status/Male: Divorced/Percentage',
        'ACS Families/Marital status/Female/Value',
        'ACS Families/Marital status/Female/Margin of error',
        'ACS Families/Marital status/Female/Percentage',
        'ACS Families/Marital status/Female: Never married/Value',
        'ACS Families/Marital status/Female: Never married/Margin of error',
        'ACS Families/Marital status/Female: Never married/Percentage',
        'ACS Families/Marital status/Female: Now married/Value',
        'ACS Families/Marital status/Female: Now married/Margin of error',
        'ACS Families/Marital status/Female: Now married/Percentage',
        'ACS Families/Marital status/Female: Now married: Married, spouse present/Value',
        'ACS Families/Marital status/Female: Now married: Married, spouse present/Margin of error',
        'ACS Families/Marital status/Female: Now married: Married, spouse present/Percentage',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent/Value',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent/Margin of error',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent/Percentage',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Separated/Value',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Separated/Margin of error',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Separated/Percentage',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Other/Value',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Other/Margin of error',
        'ACS Families/Marital status/Female: Now married: Married, spouse absent: Other/Percentage',
        'ACS Families/Marital status/Female: Widowed/Value',
        'ACS Families/Marital status/Female: Widowed/Margin of error',
        'ACS Families/Marital status/Female: Widowed/Percentage',
        'ACS Families/Marital status/Female: Divorced/Value',
        'ACS Families/Marital status/Female: Divorced/Margin of error',
        'ACS Families/Marital status/Female: Divorced/Percentage',
      ],
    },
    {
      name: 'acs-social',
      apiName: 'social',
      detailsUrl: 'https://www.geocod.io/guides/education-veteran-status-census/',
      title: '🇺🇸 Census ACS Social',
      description: null,
      bulletPoints: ['Population by minimum level of education', 'Population with veteran status', 'Period of military service (if veteran)'],
      notes: ACS_NOTES,
      columns: [
        'ACS Social/Population by minimum level of education/Total/Value',
        'ACS Social/Population by minimum level of education/Total/Margin of error',
        'ACS Social/Population by minimum level of education/Male/Value',
        'ACS Social/Population by minimum level of education/Male/Margin of error',
        'ACS Social/Population by minimum level of education/Male/Percentage',
        'ACS Social/Population by minimum level of education/Male: No schooling completed/Value',
        'ACS Social/Population by minimum level of education/Male: No schooling completed/Margin of error',
        'ACS Social/Population by minimum level of education/Male: No schooling completed/Percentage',
        'ACS Social/Population by minimum level of education/Male: Nursery to 4th grade/Value',
        'ACS Social/Population by minimum level of education/Male: Nursery to 4th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Nursery to 4th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 5th and 6th grade/Value',
        'ACS Social/Population by minimum level of education/Male: 5th and 6th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 5th and 6th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 7th and 8th grade/Value',
        'ACS Social/Population by minimum level of education/Male: 7th and 8th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 7th and 8th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 9th grade/Value',
        'ACS Social/Population by minimum level of education/Male: 9th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 9th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 10th grade/Value',
        'ACS Social/Population by minimum level of education/Male: 10th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 10th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 11th grade/Value',
        'ACS Social/Population by minimum level of education/Male: 11th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 11th grade/Percentage',
        'ACS Social/Population by minimum level of education/Male: 12th grade, no diploma/Value',
        'ACS Social/Population by minimum level of education/Male: 12th grade, no diploma/Margin of error',
        'ACS Social/Population by minimum level of education/Male: 12th grade, no diploma/Percentage',
        'ACS Social/Population by minimum level of education/Male: High school graduate (includes equivalency)/Value',
        'ACS Social/Population by minimum level of education/Male: High school graduate (includes equivalency)/Margin of error',
        'ACS Social/Population by minimum level of education/Male: High school graduate (includes equivalency)/Percentage',
        'ACS Social/Population by minimum level of education/Male: Some college, less than 1 year/Value',
        'ACS Social/Population by minimum level of education/Male: Some college, less than 1 year/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Some college, less than 1 year/Percentage',
        'ACS Social/Population by minimum level of education/Male: Some college, 1 or more years, no degree/Value',
        'ACS Social/Population by minimum level of education/Male: Some college, 1 or more years, no degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Some college, 1 or more years, no degree/Percentage',
        'ACS Social/Population by minimum level of education/Male: Associate\'s degree/Value',
        'ACS Social/Population by minimum level of education/Male: Associate\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Associate\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Male: Bachelor\'s degree/Value',
        'ACS Social/Population by minimum level of education/Male: Bachelor\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Bachelor\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Male: Master\'s degree/Value',
        'ACS Social/Population by minimum level of education/Male: Master\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Master\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Male: Professional school degree/Value',
        'ACS Social/Population by minimum level of education/Male: Professional school degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Professional school degree/Percentage',
        'ACS Social/Population by minimum level of education/Male: Doctorate degree/Value',
        'ACS Social/Population by minimum level of education/Male: Doctorate degree/Margin of error',
        'ACS Social/Population by minimum level of education/Male: Doctorate degree/Percentage',
        'ACS Social/Population by minimum level of education/Female/Value',
        'ACS Social/Population by minimum level of education/Female/Margin of error',
        'ACS Social/Population by minimum level of education/Female/Percentage',
        'ACS Social/Population by minimum level of education/Female: No schooling completed/Value',
        'ACS Social/Population by minimum level of education/Female: No schooling completed/Margin of error',
        'ACS Social/Population by minimum level of education/Female: No schooling completed/Percentage',
        'ACS Social/Population by minimum level of education/Female: Nursery to 4th grade/Value',
        'ACS Social/Population by minimum level of education/Female: Nursery to 4th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Nursery to 4th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 5th and 6th grade/Value',
        'ACS Social/Population by minimum level of education/Female: 5th and 6th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 5th and 6th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 7th and 8th grade/Value',
        'ACS Social/Population by minimum level of education/Female: 7th and 8th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 7th and 8th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 9th grade/Value',
        'ACS Social/Population by minimum level of education/Female: 9th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 9th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 10th grade/Value',
        'ACS Social/Population by minimum level of education/Female: 10th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 10th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 11th grade/Value',
        'ACS Social/Population by minimum level of education/Female: 11th grade/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 11th grade/Percentage',
        'ACS Social/Population by minimum level of education/Female: 12th grade, no diploma/Value',
        'ACS Social/Population by minimum level of education/Female: 12th grade, no diploma/Margin of error',
        'ACS Social/Population by minimum level of education/Female: 12th grade, no diploma/Percentage',
        'ACS Social/Population by minimum level of education/Female: High school graduate (includes equivalency)/Value',
        'ACS Social/Population by minimum level of education/Female: High school graduate (includes equivalency)/Margin of error',
        'ACS Social/Population by minimum level of education/Female: High school graduate (includes equivalency)/Percentage',
        'ACS Social/Population by minimum level of education/Female: Some college, less than 1 year/Value',
        'ACS Social/Population by minimum level of education/Female: Some college, less than 1 year/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Some college, less than 1 year/Percentage',
        'ACS Social/Population by minimum level of education/Female: Some college, 1 or more years, no degree/Value',
        'ACS Social/Population by minimum level of education/Female: Some college, 1 or more years, no degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Some college, 1 or more years, no degree/Percentage',
        'ACS Social/Population by minimum level of education/Female: Associate\'s degree/Value',
        'ACS Social/Population by minimum level of education/Female: Associate\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Associate\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Female: Bachelor\'s degree/Value',
        'ACS Social/Population by minimum level of education/Female: Bachelor\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Bachelor\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Female: Master\'s degree/Value',
        'ACS Social/Population by minimum level of education/Female: Master\'s degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Master\'s degree/Percentage',
        'ACS Social/Population by minimum level of education/Female: Professional school degree/Value',
        'ACS Social/Population by minimum level of education/Female: Professional school degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Professional school degree/Percentage',
        'ACS Social/Population by minimum level of education/Female: Doctorate degree/Value',
        'ACS Social/Population by minimum level of education/Female: Doctorate degree/Margin of error',
        'ACS Social/Population by minimum level of education/Female: Doctorate degree/Percentage',
        'ACS Social/Population with veteran status/Total/Value',
        'ACS Social/Population with veteran status/Total/Margin of error',
        'ACS Social/Population with veteran status/Veteran/Value',
        'ACS Social/Population with veteran status/Veteran/Margin of error',
        'ACS Social/Population with veteran status/Veteran/Percentage',
        'ACS Social/Population with veteran status/Nonveteran/Value',
        'ACS Social/Population with veteran status/Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male/Value',
        'ACS Social/Population with veteran status/Male/Margin of error',
        'ACS Social/Population with veteran status/Male/Percentage',
        'ACS Social/Population with veteran status/Male: Veteran/Value',
        'ACS Social/Population with veteran status/Male: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male: 18 to 34 years/Value',
        'ACS Social/Population with veteran status/Male: 18 to 34 years/Margin of error',
        'ACS Social/Population with veteran status/Male: 18 to 34 years/Percentage',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Veteran/Value',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 18 to 34 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male: 35 to 54 years/Value',
        'ACS Social/Population with veteran status/Male: 35 to 54 years/Margin of error',
        'ACS Social/Population with veteran status/Male: 35 to 54 years/Percentage',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Veteran/Value',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 35 to 54 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male: 55 to 64 years/Value',
        'ACS Social/Population with veteran status/Male: 55 to 64 years/Margin of error',
        'ACS Social/Population with veteran status/Male: 55 to 64 years/Percentage',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Veteran/Value',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 55 to 64 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male: 65 to 74 years/Value',
        'ACS Social/Population with veteran status/Male: 65 to 74 years/Margin of error',
        'ACS Social/Population with veteran status/Male: 65 to 74 years/Percentage',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Veteran/Value',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 65 to 74 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Male: 75 years and over/Value',
        'ACS Social/Population with veteran status/Male: 75 years and over/Margin of error',
        'ACS Social/Population with veteran status/Male: 75 years and over/Percentage',
        'ACS Social/Population with veteran status/Male: 75 years and over: Veteran/Value',
        'ACS Social/Population with veteran status/Male: 75 years and over: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 75 years and over: Veteran/Percentage',
        'ACS Social/Population with veteran status/Male: 75 years and over: Nonveteran/Value',
        'ACS Social/Population with veteran status/Male: 75 years and over: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Male: 75 years and over: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female/Value',
        'ACS Social/Population with veteran status/Female/Margin of error',
        'ACS Social/Population with veteran status/Female/Percentage',
        'ACS Social/Population with veteran status/Female: Veteran/Value',
        'ACS Social/Population with veteran status/Female: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female: 18 to 34 years/Value',
        'ACS Social/Population with veteran status/Female: 18 to 34 years/Margin of error',
        'ACS Social/Population with veteran status/Female: 18 to 34 years/Percentage',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Veteran/Value',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 18 to 34 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female: 35 to 54 years/Value',
        'ACS Social/Population with veteran status/Female: 35 to 54 years/Margin of error',
        'ACS Social/Population with veteran status/Female: 35 to 54 years/Percentage',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Veteran/Value',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 35 to 54 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female: 55 to 64 years/Value',
        'ACS Social/Population with veteran status/Female: 55 to 64 years/Margin of error',
        'ACS Social/Population with veteran status/Female: 55 to 64 years/Percentage',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Veteran/Value',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 55 to 64 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female: 65 to 74 years/Value',
        'ACS Social/Population with veteran status/Female: 65 to 74 years/Margin of error',
        'ACS Social/Population with veteran status/Female: 65 to 74 years/Percentage',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Veteran/Value',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 65 to 74 years: Nonveteran/Percentage',
        'ACS Social/Population with veteran status/Female: 75 years and over/Value',
        'ACS Social/Population with veteran status/Female: 75 years and over/Margin of error',
        'ACS Social/Population with veteran status/Female: 75 years and over/Percentage',
        'ACS Social/Population with veteran status/Female: 75 years and over: Veteran/Value',
        'ACS Social/Population with veteran status/Female: 75 years and over: Veteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 75 years and over: Veteran/Percentage',
        'ACS Social/Population with veteran status/Female: 75 years and over: Nonveteran/Value',
        'ACS Social/Population with veteran status/Female: 75 years and over: Nonveteran/Margin of error',
        'ACS Social/Population with veteran status/Female: 75 years and over: Nonveteran/Percentage',
        'ACS Social/Period of military service for veterans/Total/Value',
        'ACS Social/Period of military service for veterans/Total/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), no Gulf War (8/1990 to 8/2001), no Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), no Gulf War (8/1990 to 8/2001), no Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), no Gulf War (8/1990 to 8/2001), no Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later) and Gulf War (8/1990 to 8/2001), no Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later) and Gulf War (8/1990 to 8/2001), no Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later) and Gulf War (8/1990 to 8/2001), no Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), and Gulf War (8/1990 to 8/2001), and Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), and Gulf War (8/1990 to 8/2001), and Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (9/2001 or later), and Gulf War (8/1990 to 8/2001), and Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001), no Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001), no Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001), no Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001) and Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001) and Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Gulf War (8/1990 to 8/2001) and Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Vietnam Era, no Korean War, no World War II/Value',
        'ACS Social/Period of military service for veterans/Vietnam Era, no Korean War, no World War II/Margin of error',
        'ACS Social/Period of military service for veterans/Vietnam Era, no Korean War, no World War II/Percentage',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War, no World War II/Value',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War, no World War II/Margin of error',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War, no World War II/Percentage',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War and World War II/Value',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War and World War II/Margin of error',
        'ACS Social/Period of military service for veterans/Vietnam Era and Korean War and World War II/Percentage',
        'ACS Social/Period of military service for veterans/Korean War, no Vietnam Era, no World War II/Value',
        'ACS Social/Period of military service for veterans/Korean War, no Vietnam Era, no World War II/Margin of error',
        'ACS Social/Period of military service for veterans/Korean War, no Vietnam Era, no World War II/Percentage',
        'ACS Social/Period of military service for veterans/Korean War and World War II, no Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/Korean War and World War II, no Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/Korean War and World War II, no Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/World War II, no Korean War, no Vietnam Era/Value',
        'ACS Social/Period of military service for veterans/World War II, no Korean War, no Vietnam Era/Margin of error',
        'ACS Social/Period of military service for veterans/World War II, no Korean War, no Vietnam Era/Percentage',
        'ACS Social/Period of military service for veterans/Between Gulf War and Vietnam Era only/Value',
        'ACS Social/Period of military service for veterans/Between Gulf War and Vietnam Era only/Margin of error',
        'ACS Social/Period of military service for veterans/Between Gulf War and Vietnam Era only/Percentage',
        'ACS Social/Period of military service for veterans/Between Vietnam Era and Korean War only/Value',
        'ACS Social/Period of military service for veterans/Between Vietnam Era and Korean War only/Margin of error',
        'ACS Social/Period of military service for veterans/Between Vietnam Era and Korean War only/Percentage',
        'ACS Social/Period of military service for veterans/Between Korean War and World War II only/Value',
        'ACS Social/Period of military service for veterans/Between Korean War and World War II only/Margin of error',
        'ACS Social/Period of military service for veterans/Between Korean War and World War II only/Percentage',
        'ACS Social/Period of military service for veterans/Pre-World War II only/Value',
        'ACS Social/Period of military service for veterans/Pre-World War II only/Margin of error',
        'ACS Social/Period of military service for veterans/Pre-World War II only/Percentage',
      ],
    },
    {
      name: 'ffiec',
      apiName: 'ffiec',
      detailsUrl: 'https://www.geocod.io/guides/ffiec-data/',
      title: '🇺🇸 FFIEC CRA/HMDA Data (Beta)',
      description: null,
      bulletPoints: [
        'Tract Income Level',
        'Underserved or Distressed Tract',
        'CRA Criteria',
        'Urban/Rural Code',
      ],
      notes: ['FFIEC Data is currently in public beta. Column names and data included may change in the future.'],
      columns: [
        'HMDA/CRA collection year',
        'MSA/MD Code',
        'FIPS state code',
        'FIPS county code',
        'Census tract',
        'Principal city?',
        'Small county code',
        'Small county description',
        'Split tract code',
        'Split tract description',
        'Demographic data code',
        'Demographic data description',
        'Urban/rural code',
        'Urban/rural description',
        'MSA/MD median family income',
        'MSA/MD median household income',
        'Tract median family income as a percentage of the MSA/MD median family income',
        'FFIEC Estimated MSA/MD median family income',
        'Income indicator',
        'CRA poverty criteria?',
        'CRA unemployment criteria?',
        'CRA distressed criteria?',
        'CRA remote rural (low density) criteria?',
        'Previous year CRA distressed criteria?',
        'Previous year CRA underserved criterion?',
        'Meets at least one of current or previous year\'s CRA distressed/underserved tract criteria?',
      ],
    },
    {
      name: 'statcan',
      apiName: 'statcan',
      detailsUrl: 'https://www.geocod.io/guides/statcan/',
      title: '🇨🇦 Statistics Canada Geographies',
      description: null,
      bulletPoints: ['Census Division', 'Census Subdivision', 'Census Economic Region', 'Census Statistical Area Code'],
      columns: [
        'Statcan Census Division id',
        'Statcan Census Division Name',
        'Statcan Census Division Type',
        'Statcan Census Division Type Description',
        'Statcan Census Consolidated Subdivision id',
        'Statcan Census Consolidated Subdivision Name',
        'Statcan Census Subdivision id',
        'Statcan Census Subdivision Name',
        'Statcan Census Subdivision Type',
        'Statcan Census Subdivision Type Description',
        'Statcan Census Economic Region',
        'Statcan Census Statistical Area Code',
        'Statcan Census Statistical Area Code Description',
        'Statcan Census Statistical Area Type',
        'Statcan Census Statistical Area Type Description',
        'Statcan Census CMA/CA id',
        'Statcan Census CMA/CA Name',
        'Statcan Census CMA/CA Type',
        'Statcan Census CMA/CA Type Description',
        'Statcan Census Tract',
        'Statcan Census Year',
      ],
    },
  ],
  districts: [
    {
      name: 'cd',
      apiName: 'congressional_districts',
      detailsUrl: 'https://www.geocod.io/guides/congressional-data/',
      title: '🇺🇸 Congressional Districts',
      defaultOption: currentCongress,
      options: {
        'cd119': 'Districts as of the 119th Congress' + (currentCongress === 'cd119' ? ' (current)' : ' (upcoming)'),
        'cd118': 'Districts as of the 118th Congress' + (currentCongress === 'cd118' ? ' (current)' : ''),
        'cd117': 'Districts as of the 117th Congress',
        'cd116': 'Districts as of the 116th Congress',
        'cd115': 'Districts as of the 115th Congress',
        'cd114': 'Districts as of the 114th Congress',
        'cd113': 'Districts as of the 113th Congress',
      },
      description: null,
      bulletPoints: ['District name and number', 'Congress number', 'OCD ID'],
      notes: [
        'If Congressional data appends are requested for a postal code lookup and there are multiple possible',
        'Congressional districts, we will only append the Congressional district with the best match.',
        'To get a full list of possible Congressional district, you will need to use our API.',
      ],
      columns: [
        'Congressional District',
        'Congress',
        'OCD ID',
      ],
      subfields: [{
        name: 'cd+legislators',
        detailsUrl: '',
        title: 'Add Representative/Senator Info? (Free)',
        description: 'Adds contact info and more for current Members of Congress and Senate.',
        columns: [
          'Congressional District',
          'Congress',
          'OCD ID',

          'Current Representative Last name',
          'Current Representative First name',
          'Current Representative Birthday',
          'Current Representative Gender',
          'Current Representative Party',
          'Current Representative Url',
          'Current Representative Address',
          'Current Representative Phone',
          'Current Representative Contact form',
          'Current Representative RSS url',
          'Current Representative Twitter',
          'Current Representative Facebook',
          'Current Representative YouTube',
          'Current Representative YouTube id',
          'Current Representative Bioguide id',
          'Current Representative Thomas id',
          'Current Representative OpenSecrets id',
          'Current Representative LIS id',
          'Current Representative C-SPAN id',
          'Current Representative GovTrack id',
          'Current Representative Vote Smart id',
          'Current Representative Ballotpedia id',
          'Current Representative Washington post id',
          'Current Representative ICPSR id',
          'Current Representative Wikipedia id',
          'Current Representative Source',

          'Current Senator #1 Last name',
          'Current Senator #1 First name',
          'Current Senator #1 Seniority',
          'Current Senator #1 Birthday',
          'Current Senator #1 Gender',
          'Current Senator #1 Party',
          'Current Senator #1 Url',
          'Current Senator #1 Address',
          'Current Senator #1 Phone',
          'Current Senator #1 Contact form',
          'Current Senator #1 RSS url',
          'Current Senator #1 Twitter',
          'Current Senator #1 Facebook',
          'Current Senator #1 YouTube',
          'Current Senator #1 YouTube id',
          'Current Senator #1 Bioguide id',
          'Current Senator #1 Thomas id',
          'Current Senator #1 OpenSecrets id',
          'Current Senator #1 LIS id',
          'Current Senator #1 C-SPAN id',
          'Current Senator #1 GovTrack id',
          'Current Senator #1 Vote Smart id',
          'Current Senator #1 Ballotpedia id',
          'Current Senator #1 Washington post id',
          'Current Senator #1 ICPSR id',
          'Current Senator #1 Wikipedia id',
          'Current Senator #1 Source',

          'Current Senator #2 Last name',
          'Current Senator #2 First name',
          'Current Senator #2 Seniority',
          'Current Senator #2 Birthday',
          'Current Senator #2 Gender',
          'Current Senator #2 Party',
          'Current Senator #2 Url',
          'Current Senator #2 Address',
          'Current Senator #2 Phone',
          'Current Senator #2 Contact form',
          'Current Senator #2 RSS url',
          'Current Senator #2 Twitter',
          'Current Senator #2 Facebook',
          'Current Senator #2 YouTube',
          'Current Senator #2 YouTube id',
          'Current Senator #2 Bioguide id',
          'Current Senator #2 Thomas id',
          'Current Senator #2 OpenSecrets id',
          'Current Senator #2 LIS id',
          'Current Senator #2 C-SPAN id',
          'Current Senator #2 GovTrack id',
          'Current Senator #2 Vote Smart id',
          'Current Senator #2 Ballotpedia id',
          'Current Senator #2 Washington post id',
          'Current Senator #2 ICPSR id',
          'Current Senator #2 Wikipedia id',
          'Current Senator #2 Source',
        ],
      },
      ],
    },
    {
      name: 'stateleg',
      apiName: 'state_legislative_districts',
      detailsUrl: 'https://www.geocod.io/guides/state-legislative-districts/',
      title: '🇺🇸 State Legislative Districts',
      description: null,
      bulletPoints: ['Upper and Lower House Name', 'Upper and Lower House Number', 'Upper and Lower House OCD ID'],
      columns: [
        'State Legislative District House Name',
        'State Legislative District House Number',
        'State Legislative District House OCD ID',
        'State Legislative District House Proportion',
        'State Legislative District Senate Name',
        'State Legislative District Senate Number',
        'State Legislative District Senate OCD ID',
        'State Legislative District Senate Proportion',
      ],
    },
    {
      name: 'school',
      apiName: 'school_districts',
      detailsUrl: 'https://www.geocod.io/guides/school-districts/',
      title: '🇺🇸 School Districts',
      description: null,
      bulletPoints: ['Unified School District', 'Elementary School District', 'Secondary School District'],
      columns: [
        'Unified School District Name',
        'Unified School District LEA code',
        'Unified School District Grade Low',
        'Unified School District Grade High',
        'Elementary School District Name',
        'Elementary School District LEA code',
        'Elementary School District Grade Low',
        'Elementary School District Grade High',
        'Secondary School District Name',
        'Secondary School District LEA code',
        'Secondary School District Grade Low',
        'Secondary School District Grade High',
      ],
    },
    {
      name: 'riding-next',
      apiName: 'riding-next',
      detailsUrl: 'https://www.geocod.io/guides/ridings/',
      title: '🇨🇦 Canadian Federal Ridings (Electoral Districts)',
      defaultOption: 'riding-next',
      options: {
        'riding-next': 'Upcoming ridings',
        'riding': 'Current ridings',
      },
      description: null,
      bulletPoints: ['Riding code', 'OCD ID', 'English and French riding name'],
      columns: [
        'Federal Riding Code',
        'Federal Riding OCD ID',
        'Federal Riding Name (French)',
        'Federal Riding Name (English)',
        'Federal Riding Source',
      ],
    },
    {
      name: 'provriding',
      apiName: 'provriding',
      detailsUrl: 'https://www.geocod.io/guides/provincial-territorial-ridings/',
      title: '🇨🇦 Canadian Provincial/Territorial Ridings (Electoral Districts)',
      description: null,
      bulletPoints: ['Provincial/Territorial Riding OCD ID', 'English and French riding name'],
      columns: [
        'Provincial/Territorial Riding OCD ID',
        'Provincial/Territorial Riding Name (French)',
        'Provincial/Territorial Riding Name (English)',
        'Provincial/Territorial Riding Source',
      ],
    },
  ],
  other: [
    {
      name: 'zip4',
      apiName: 'zip4',
      detailsUrl: 'https://www.geocod.io/guides/zip4/',
      title: '🇺🇸 USPS ZIP+4 data',
      description: null,
      bulletPoints: ['ZIP+4', 'ZIP 9 Range', 'Record Type Code', 'Residential Indicator (RDI)'],
      columns: [
        'ZIP+4 Range Start',
        'ZIP+4 Range End (or blank if no range)',
        'ZIP 9 Range Start',
        'ZIP 9 Range End (or blank if no range)',
        'Record Type Code',
        'Record Type Description',
        'Residential Indicator',
        'Carrier Route ID',
        'Carrier Route Description',
        'Building or Firm Name',
        'Government Building Code',
        'Government Building Description',
        'Facility Code',
        'Facility Description',
        'City Delivery?',
        'Valid delivery area?',
        'Exact Match?',
      ],
    },
    {
      name: 'timezone',
      apiName: 'timezone',
      detailsUrl: 'https://www.geocod.io/guides/timezones/',
      title: '🌎 Timezone',
      description: null,
      bulletPoints: ['Timezone name', 'Timezone abbreviation', 'Timezone UTC offset'],
      columns: [
        'Timezone Name',
        'Timezone Abbreviation',
        'Timezone UTC Offset',
        'Timezone Observes Daylight Savings',
      ],
    },
  ],
}
